export default __webpack_public_path__ + "static/media/secure.a584f815.svg";